export default {
  category: Object.freeze({
    TREATMENT_DIARY: 'treatment-diary', DENTAL_LABORATORY_PURCHASE_ORDER: 'dental-laboratory-purchase-order',
    TREATMENT_PRESENTATION: 'treatment-presentation'
  })
}
